import styled from "@emotion/styled";
import { WHITE, LIGHT_BLUE, APP_TEMA, BEI_JYO, GREY } from "../../styles/color";

export const ApplyWrap = styled.div`
  width: 100%;
`;

export const ApplyTitle = styled.h2`
  margin: 0 0 20px;
  color: ${APP_TEMA};
  text-align: left;
`;

export const ApplyCard = styled.div`
  background-color: ${WHITE};
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
`;

export const ApplyBody = styled.div`
  max-width: 720px;
  margin-right: auto;
  margin-left: auto;
`;

export const ApplyEventInfo = styled.div`
  background-color: ${BEI_JYO};
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  text-align: left;
  white-space: pre-line;
  font-size: 15px;
  font-weight: bold;
  color: #333;
`;

export const ApplyImage = styled.div`
  margin-bottom: 15px;
  max-width: 100%;
  text-align: center;

  img {
    max-width: 100%;
    max-height: 300px;
    object-fit: contain;
    border-radius: 8px;
  }
`;

export const ApplyField = styled.div`
  margin-bottom: 15px;
  text-align: left;
`;

export const ApplyLabel = styled.label`
  display: block;
  font-size: 13px;
  font-weight: bold;
  color: #444;
  margin-bottom: 5px;
`;

export const ApplyInput = styled.input`
  width: 100%;
  padding: 8px 10px;
  font-size: 14px;
  border: 1px solid ${GREY};
  border-radius: 4px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: ${LIGHT_BLUE};
    box-shadow: 0 0 0 2px rgba(0, 149, 255, 0.2);
  }
`;

export const ApplyTextArea = styled.textarea`
  width: 100%;
  padding: 8px 10px;
  font-size: 14px;
  border: 1px solid ${GREY};
  border-radius: 4px;
  box-sizing: border-box;
  resize: vertical;
  min-height: 70px;

  &:focus {
    outline: none;
    border-color: ${LIGHT_BLUE};
    box-shadow: 0 0 0 2px rgba(0, 149, 255, 0.2);
  }
`;

export const ApplyButton = styled.button`
  margin-top: 20px;
  padding: 12px 30px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 30px;
  background-color: ${APP_TEMA};
  color: ${WHITE};
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }

  &:disabled,
  &[aria-disabled="true"] {
    background-color: ${GREY};
    cursor: not-allowed;
  }
`;

export const ApplyMutedText = styled.span`
  color: ${GREY};
  font-size: 13px;
`;
